export default __webpack_public_path__ + "static/media/contacto_m_bg.5ba4e91d.png";